export const valueToPercent = (min, max, value) =>
  ((100 * (value - min)) / (max - min)).toFixed(6);
